import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["themeSelect"]  // 테마 선택용 select 엘리먼트가 있는 경우

  static values = {
    storageKey: { type: String, default: 'theme-preference' },
    themes: { type: Object, default: { DARK: 'dark', LIGHT: 'light', SYSTEM: 'system' } }
  }

  connect() {
    this.initialize()
  }

  initialize() {
    this.applyTheme()
    this.initializeThemeListeners()

    // select 엘리먼트가 있다면 저장된 테마로 초기값 설정
    if (this.hasThemeSelectTarget) {
      this.themeSelectTarget.value = this.getSavedTheme()
    }
  }

  // 시스템 다크 모드 확인
  getSystemTheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? this.themesValue.DARK
      : this.themesValue.LIGHT
  }

  // 저장된 사용자 선호도 가져오기
  getSavedTheme() {
    return localStorage.getItem(this.storageKeyValue) || this.themesValue.SYSTEM
  }

  // 실제 적용할 테마 결정
  getEffectiveTheme() {
    const savedTheme = this.getSavedTheme()
    return savedTheme === this.themesValue.SYSTEM
      ? this.getSystemTheme()
      : savedTheme
  }

  // HTML에 테마 적용
  applyTheme() {
    const theme = this.getEffectiveTheme()
    document.documentElement.setAttribute('data-theme', theme)
  }

  // 테마 설정 (data-action으로 호출될 메서드)
  setTheme(event) {
    const theme = event.currentTarget.dataset.theme || event.currentTarget.value
    localStorage.setItem(this.storageKeyValue, theme)
    this.applyTheme()
  }

  // 이벤트 리스너 설정
  initializeThemeListeners() {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (this.getSavedTheme() === this.themesValue.SYSTEM) {
        this.applyTheme()
      }
    })
  }
}
